<template>
	<el-dialog :visible.sync="is_visible" :width="'30%'" @close="hide">
		<template slot="title">
			<h3 class="mb-0 font-weight-600">Pre-screening Credit Loan Eligibility</h3>
		</template>
		<div class="table-simple-modal">
			<b-table-simple responsive bordered>
				<b-tbody>
					<tr>
						<th>
							Type of Loan
						</th>
						<td>
							<el-select v-model="form.type_loan" placeholder="Select"  class="w-100" @change="calculate" >
								<el-option v-for="item in optionLoanType" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</td>
					</tr>
					<tr>
						<th>
							Loan Tenure
						</th>
						<td>
							<el-select v-model="form.loan_tenure" placeholder="Select" @change="calculate"  class="w-100">
								<el-option v-for="(item, index) in loanTenureOpt" :key="index" :label="item + ' Year'" :value="item">
								</el-option>
							</el-select>
						</td>
					</tr>
					<tr>
						<th>
							Advance Insurance
						</th>
						<td>
							<b-form-input type="text" v-model="form.adv_insurance" @keydown="_gHlp.checkNonNumericInput" @blur="calculate"  class="w-100"></b-form-input>
						</td>
					</tr>
					<tr>
						<th>
							Loan Amount
						</th>
						<td>
							RM {{ _gHlp.getValue(detail, 'loan_amount', 0) | moneyFormatter }}
						</td>
					</tr>
					<tr>
						<th>
							Interest Rate
						</th>
						<td>
							{{ interestRate }}
						</td>
					</tr>
					<tr>
						<th>
							Loan Tenure
						</th>
						<td>
							{{ form.loan_tenure }} Year
						</td>
					</tr>
					<tr>
						<th>
							Monthly Installment
						</th>
						<td>
							RM {{ _gHlp.getValue(detail, 'installment', 0) | moneyFormatter }}
						</td>
					</tr>
					<tr>
						<th>
							Stamp Duty Fees
						</th>
						<td>
							RM {{ _gHlp.getValue(detail, 'stamp_duty', 0) | moneyFormatter }}
						</td>
					</tr>
					<tr>
						<th>
							Legal Fees
						</th>
						<td>
							RM {{ _gHlp.getValue(detail, 'legal_fees', 0) | moneyFormatter }}
						</td>
					</tr>
					<tr>
						<th>
							{{ this.form.adv_insurance > 0 ? 'Advance Annual Premium' : 'Stakeholder Sum' }}
						</th>
						<td>
							RM {{ _gHlp.getValue(detail, 'stakeholder_sum', 0) | moneyFormatter }}
						</td>
					</tr>
					<tr>
						<th>
							Vetting and Facilities Service Fees
						</th>
						<td>
							RM {{ _gHlp.getValue(detail, 'vf_service_fees', 0) | moneyFormatter }}
						</td>
					</tr>
					<tr>
						<th>
							Debt Console Amount
						</th>
						<td>
							RM {{ dept_console_amount | moneyFormatter }}
						</td>
					</tr>
					<tr>
						<th>
							Disbursement Amount
						</th>
						<td>
							RM {{ _gHlp.getValue(detail, 'disbursement_to_client', 0) | moneyFormatter }}
						</td>
					</tr>
				</b-tbody>
			</b-table-simple>
			<div class="d-flex justify-content-center" v-if="allow_save">
				<el-button class="bg-primary text-white" @click="saveFees" :loading="is_loading">Save</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
import {cloneDeep, isEqual} from 'lodash'
import { Dialog, Select, Option, Button } from 'element-ui'
import { calculateInvinitySettlement } from '@/assets/js/calculator'

import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'

export default {
	props: ['proposal'],
	components: {
		[Button.name]: Button,
		[Dialog.name]: Dialog,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			is_visible: false,
			is_loading:false,
			detail: {},
			fees_charges: [],
			form: {
				type_loan: '',
				loan_tenure: '',
				adv_insurance: 0,
			},
			optionLoanType: [
				{
					label: 'Secure Loan',
					value: 'Secure Loan',
					years: [1, 2, 3, 4, 5, 6, 7],
					interest_rate: 12,
				},
				{
					label: 'Unsecure Loan',
					value: 'Unsecure Loan',
					years: [1, 2, 3, 4, 5],
					interest_rate: 18,
				},
			]
		}
	},
	computed: {
		...mapState(useInvinityStore, ['currentInvSummary']),
		dept_console_amount() {
			return _gHlp.getValue(this.currentInvSummary, 'debt_console_amount', _gHlp.getValue(this.proposal, 'summary_ccris_track.total_inv_settlement', 0));
		},
		loanTenureOpt() {
			if (_gHlp.isEmpty(this.form.type_loan)) return [1, 2, 3, 4, 5];
			let ltype = this.optionLoanType.find(itm => itm.value === this.form.type_loan)
			return ltype.years || [];
		},
		interestRate() {
			if (_gHlp.isEmpty(this.form.type_loan)) return 0;
			let ltype = this.optionLoanType.find(itm => itm.value === this.form.type_loan)
			return ltype.interest_rate;
		},
		allow_save(){
			return _gHlp.isEmpty(this.proposal.psal_invinity_id)
		}
	},
	methods: {
		...mapActions(useInitialProposalStore, ['updateProposal','bulkUpSertFeesCharges']),
		show() {
			this.detail = _gHlp.getValue(this.proposal,'psal_invcalc_json',{});
			this.form.type_loan = _gHlp.getValue(this.proposal,'psal_invcalc_json.type_loan',null);
			this.form.loan_tenure = _gHlp.getValue(this.proposal,'psal_invcalc_json.loan_tenure',null);
			this.form.adv_insurance = _gHlp.getValue(this.proposal,'psal_invcalc_json.adv_insurance',0);
			this.fees_charges = _gHlp.getValue(this.proposal,'fees_charges',[]);
			this.is_visible = true
		},
		hide() {
			this.is_visible = false
		},
		calculate() {
			if(_gHlp.isEmpty(this.dept_console_amount) || 
				 _gHlp.isEmpty(this.form.loan_tenure)) return false;

			let params = {
				debt_amount: this.dept_console_amount,
				tenure_year: this.form.loan_tenure,
				adv_insurance: this.form.adv_insurance,
				interest_rate: this.interestRate,
				vf_service_rate: this.form.adv_insurance > 0 ? 0.08 : 0.1
				// credit_loan:	
			}
			this.detail = calculateInvinitySettlement(params);
			this.detail['type_loan'] = this.form.type_loan;
			this.detail['loan_tenure'] = this.form.loan_tenure;
			this.detail['adv_insurance'] = this.form.adv_insurance;
			this.detail['interest_rate'] = this.interestRate;
		},
		generateItemFees(){
				let feesData = {
					stamp_duty: parseFloat(_gHlp.getValue(this.detail, 'stamp_duty', 0)),
					vf_service_fees: parseFloat(_gHlp.getValue(this.detail, 'vf_service_fees', 0)),
					stakeholder_sum: parseFloat(_gHlp.getValue(this.detail, 'stakeholder_sum', 0)),
					legal_fees: parseFloat(_gHlp.getValue(this.detail, 'legal_fees', 0)),
				}
				
				const curStampDuty = this.fees_charges.find(itm => itm.pfee_type == 'Stamp Duty');
				const curLegalFee = this.fees_charges.find(itm => itm.pfee_type == 'Legal Fees');
				const curStakeHolder = this.fees_charges.find(itm => itm.pfee_type == 'Stakeholder Sum');
				const curVFService = this.fees_charges.find(itm => itm.pfee_type == 'Vetting and Facilitation Services');

				return [
					{
						pfee_id: _gHlp.getValue(curStampDuty,'pfee_id',null),
						pfee_psal_id: _gHlp.getValue(curStampDuty,'pfee_psal_id',null),
						pfee_type: 'Stamp Duty',
						pfee_description: _gHlp.getValue(curStampDuty,'pfee_description',null),
						pfee_outstanding: parseFloat(_gHlp.getValue(feesData, 'stamp_duty', 0)),
					},
					{
						pfee_id: _gHlp.getValue(curLegalFee,'pfee_id',null),
						pfee_psal_id: _gHlp.getValue(curLegalFee,'pfee_psal_id',null),
						pfee_type: 'Legal Fees',
						pfee_description: _gHlp.getValue(curLegalFee,'pfee_description',null),
						pfee_outstanding: parseFloat(_gHlp.getValue(feesData, 'legal_fees', 0)),
					},
					{
						pfee_id: _gHlp.getValue(curStakeHolder,'pfee_id',null),
						pfee_psal_id: _gHlp.getValue(curStakeHolder,'pfee_psal_id',null),
						pfee_type: 'Stakeholder Sum',
						pfee_description: _gHlp.getValue(curStakeHolder,'pfee_description',null),
						pfee_outstanding: parseFloat(_gHlp.getValue(feesData, 'stakeholder_sum', 0)),
					},
					{
						pfee_id: _gHlp.getValue(curVFService,'pfee_id',null),
						pfee_psal_id: _gHlp.getValue(curVFService,'pfee_psal_id',null),
						pfee_type: 'Vetting and Facilitation Services',
						pfee_description: _gHlp.getValue(curVFService,'pfee_description',null),
						pfee_outstanding: parseFloat(_gHlp.getValue(feesData, 'vf_service_fees', 0)),
					}
				]
		},
		async saveFees(){
			this.is_loading = true;
			this.calculate();
			let itemFees = this.generateItemFees();
			let psal_id = _gHlp.getValue(this.proposal,'psal_id');
			let oldItemFees = cloneDeep(this.fees_charges);
			let newItemFees = _gHlp.patchData(this.fees_charges,itemFees,'pfee_type');
			
			let resp  = await this.bulkUpSertFeesCharges(psal_id,newItemFees,oldItemFees,!_gHlp.isEmpty(this.proposal.psal_invinity_id));
			if(resp){
				_gNotif.notifySuccess('<b>Fees And Charges</b> - Successfully Sync With Calculator.')
			}
			this.updateProposal(psal_id,{psal_invcalc_json:this.detail})
			this.is_loading = false;
			this.hide();
		},
	}
}
</script>